import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ApiConfigurationState, CoreState, InvAction } from '../interfaces';

const API_CONFIGURATION_NAMESPACE = 'apiConfiguration';

const INITIAL_STATE: ApiConfigurationState = {
  isConfigured: false,
  key: ''
};

// Reducers
const slice = createSlice({
  initialState: INITIAL_STATE,
  name: API_CONFIGURATION_NAMESPACE,
  reducers: {
    setIsApiConfigured(state, action: InvAction<boolean>) {
      state.isConfigured = action.payload;
    },
    setApiKey(state, action: InvAction<string>) {
      state.key = action.payload;
    }
  }
});

export const apiConfiguration = slice.reducer;

// Actions
export const { setApiKey, setIsApiConfigured } = slice.actions;

// Selectors
const getApiConfiguration = (state: CoreState) =>
  state.core[API_CONFIGURATION_NAMESPACE];

export const getApiKey = createSelector(
  [getApiConfiguration],
  (configuration) => configuration.key
);

export const getIsApiConfigured = createSelector(
  [getApiConfiguration],
  (configuration) => configuration.isConfigured
);
